<template>
  <div id="repairModeManage">
    <div class="repair container">
      <h4>维修方式</h4>
      <ul class="clearfix">
        <li @click="selectRepairClass(item,index)" v-for="(item,index) in repairLists" :key="index" class="repairListPart listPart" :class="{'active': item.isLength}">
          <span v-bind:class="{active:activeRepairIndex===index}"><i class="el-icon-check"></i></span>
          <p>{{item.solutionName}}</p>
          <span class="exitBtn" @click.stop="exitRepair(item)" v-if="repairAuth.exitRepair">编辑</span>
          <i class="el-icon-error activeDelBtn" @click.stop="deleRepair(item)" v-if="repairAuth.deleRepair"></i>
        </li>
        <li class="addContent" @click="newRepair()" v-if="repairAuth.newRepair"><i class="el-icon-plus"></i></li>
      </ul>
      <el-dialog :title="textRepairMenu[dialogRepairStatus]" :visible.sync="dislogRepair" :close-on-click-modal="false" width="600px"  @close="emptyRepairDialog('RepairForm')">
        <el-form ref="RepairForm" :model="RepairForm" label-width="100px" :label-position="labelPosition" 
        :rules="RepairFormRules">
          <el-form-item label="维修方式：" prop="solutionName">
            <el-input clearable v-model.trim="RepairForm.solutionName" placeholder="请输入维修方式(不超过200字)" maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" >
          <el-button v-if="dialogRepairStatus!=='update'" type="success" @click="addRepairFormSubmitBtn('RepairForm')">添加</el-button>
          <el-button v-else type="success" @click="saveRepairFormSubmitBtn('RepairForm')">保存</el-button> 
          <el-button @click="emptyRepairDialog('RepairForm')">取 消</el-button> 
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {getPermission} from '../../api/authRequest'

  import {
    insertSolution,selectSolution,updateSolution,deleteSolution
  } from "../../api/api";
  export default {
    name: 'repairModeManage',
    data() {
      const validateNumber = (rule, value, callback) => {
        if (value.length > 200 || !value) {
            callback(new Error("维修方式不能为空且不超过200字"));
        }else {
            callback();
        }
      }
      return {
        labelPosition:'left',
        activeRepairIndex:0,
        //维修方式部分
        dislogRepair:false,
        dialogRepairStatus: "",
        textRepairMenu: {
          update: "修改维修方式",
          create: "新增维修方式"
        },
        RepairForm:{
          solutionName: '',
        },
        RepairFormRules:{
          solutionName: [{ required: true, validator: validateNumber, trigger: "blur" }],
        },
        repairLists:[],
        repairAuth:{
          newRepair:false,
          exitRepair:false,
          deleRepair:false,
        }
      }
    },
    mounted () {
      this.getRepairList()
      this.repairAuth.newRepair= getPermission('/api/basicSetting/Solution/insertSolution');
      this.repairAuth.exitRepair= getPermission('/api/basicSetting/Solution/updateSolution');
      this.repairAuth.deleRepair= getPermission('/api/basicSetting/Solution/delete1Solution');
    },
    components: {
    },
    methods: {
      //清空dialog--维修方式
      emptyRepairDialog(formName) {
        this.$refs[formName].resetFields();
        this.dislogRepair = false
      },

      //选择故障分类
      selectRepairClass(item,index) {
        this.activeRepairIndex = index
        this.RepairForm = Object.assign({}, item);
        this.getRepairList()
      },
      //获取维修方式列表
      getRepairList() {
        selectSolution().then(res => {
          if (res.data.status==100) {
            this.repairLists = res.data.results
            this.repairLists.forEach((item,index)=>{
              this.repairLists[index].isLength = (this.repairLists[index].solutionName.length <= 12) ? true : false;
            })
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //新增维修方式
      newRepair() {
        this.dislogRepair = true
        this.dialogRepairStatus = "create";
      },
      //确定新增维修方式
      addRepairFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            // console.log('验证成功')
            let para={
              solutionName: this.RepairForm.solutionName,
            }
            insertSolution(para).then(res => {
                if (res.data.status=='100') {
                    this.$message({
                        message: res.data.message,
                        type: "success"
                    });
                    /*关闭弹窗，重置输入框*/
                    this.dislogRepair = false;
                    this.$refs[formname].resetFields();
                    /*刷新*/
                    this.getRepairList();
                }else{
                    this.$message({
                        message: res.data.message,
                        type: "error"
                    });
                }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //编辑维修方式
      exitRepair(item) {
        this.dislogRepair = true
        this.dialogRepairStatus = "update";
        this.RepairForm = Object.assign({}, item);
      },
      //确定保存维修方式
      saveRepairFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            // console.log('验证成功')
            let para={
              solutionId:this.RepairForm.solutionId,
              solutionName:this.RepairForm.solutionName
            }
            updateSolution(para).then(res => {
                if (res.data.status=='100') {
                    this.$message({
                        message: res.data.message,
                        type: "success"
                    });
                    /*关闭弹窗，重置输入框*/
                    this.dislogRepair = false;
                    this.$refs[formname].resetFields(); 
                    /*刷新*/
                    this.getRepairList();
                }else{
                    this.$message({
                        message: res.data.message,
                        type: "error"
                    });
                }
            }).catch((error) =>{
                this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
     //删除维修方式
      deleRepair(item) {
        this.RepairForm = Object.assign({}, item);
        this.$confirm("确认删除该维修方式?", "提示", {
          type: "warning"
        }).then(() => {
          let para={
              solutionId:this.RepairForm.solutionId,
            }
          deleteSolution(para).then((res) => {
            if (res.data.status == '100') {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              /*刷新*/
                this.getRepairList();
                this.RepairForm = {}
            }else{
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          })
        }).catch(() => {});
      },
      
    },
    computed: {
    },
    watch: {
      
    }
  }
</script>

<style lang="scss" type="text/css" scoped>
    #repairModeManage{
        .clearfix{
            clear:both;
            overflow: hidden;
        }
        .container{
            border-bottom: 1px solid #c6c6c6;
            padding-bottom: 20px;
            h4{
                margin: 15px 0;
                font-weight: 500;
                font-size: 16px;
            }
            .faultContent{
                width: 80px;
                line-height: 30px;
                height: 30px;
                font-size: 14px;
                text-align: left;
            }
            .listPart{
                width: 140px;
                float: left;
                margin:0 15px 10px 0;
                border-radius: 10px;
                height: 85px;
                line-height: 2;
                padding:10px 10px 40px;
                overflow:hidden;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; //行数
                -webkit-box-orient: vertical;
                border: 1px solid #10c55b;
                    & > span:first-child{
                        display:none;
                    }
                span.active{
                    position: absolute;
                    top: -1px;
                    right:-1px;
                    display: block;
                    width: 30px;
                    height: 30px;
                    border-width: 16px;
                    border-style: solid;
                    border-color: #1abc9c #1abc9c #fff #fff;
                    border-top-right-radius:10px;
                    i{
                        position: absolute;
                        font-size: 14px;
                        color:#fff;
                        top: -9px;
                    }
                }
                span.exitBtn{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    line-height: 20px;
                    left: 0;
                    border-top:1px solid #10c55b;
                    z-index:1;display: block;
                    background-color:#d7ffe8;
                    border-radius: 0 0 10px 10px;
                    color:#10c55b;
                }
                i.activeDelBtn{
                    display: none;
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    color: #E03B5B;
                }
                p{
                    font-size:12px; 
                    color:#495060;
                    width:100%
                }
            }
            .active{
                line-height:50px;
                background-color:transparent
            }
            .listPart:hover{
                box-shadow: 2px 2px 2px #c6c6c6;
            }
            .listPart:hover i.activeDelBtn{
                display: block;
            }
            .addContent{
                border:1px dashed #c6c6c6;
                width: 50px;
                height: 50px;
                line-height: 50px;
                float: left;
                text-align: center;
                margin-top: 15px;cursor: pointer;
                i{
                    font-size: 20px;
                }
            }
            .contentPart{
                width: 80px;
                float: left;
                border:1px solid #c6c6c6;
                margin:0 15px 10px 0;
                border-radius: 5px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
            }
            .activeContent{
                background-color: #1abc9c;
                color: #fff;
                border-color: #fff;
            }
            .el-checkbox.is-bordered+.el-checkbox.is-bordered {
                margin-left: 15px;
            }
        } 
        .container:first-child{
            border-color: transparent;
        }
    }
</style>



// WEBPACK FOOTER //
// repairModeManage.vue?aa127118